'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        defaultCellStyleBackground: {
            type: String,
            default: undefined,
            kComposite: 'defaultCellStyle.background'
        },
        defaultCellStyleColor: {
            type: String,
            default: undefined,
            kComposite: 'defaultCellStyle.color'
        },
        defaultCellStyleFontFamily: {
            type: String,
            default: undefined,
            kComposite: 'defaultCellStyle.fontFamily'
        },
        defaultCellStyleFontSize: {
            type: String,
            default: undefined,
            kComposite: 'defaultCellStyle.fontSize'
        },
        defaultCellStyleItalic: {
            type: Boolean,
            default: undefined,
            kComposite: 'defaultCellStyle.Italic'
        },
        defaultCellStyleBold: {
            type: Boolean,
            default: undefined,
            kComposite: 'defaultCellStyle.bold'
        },
        defaultCellStyleUnderline: {
            type: Boolean,
            default: undefined,
            kComposite: 'defaultCellStyle.underline'
        },
        defaultCellStyleWrap: {
            type: Boolean,
            default: undefined,
            kComposite: 'defaultCellStyle.wrap'
        }
    }
};